import { apiService } from './apiService';

export const superAdminApi = {
  // Authentication
  login: async (credentials) => {
    return apiService.post('/super-admin/login', credentials);
  },

  logout: async () => {
    return apiService.post('/super-admin/logout');
  },

  getProfile: async () => {
    return apiService.get('/super-admin/me');
  },

  refreshToken: async () => {
    return apiService.post('/super-admin/refresh');
  },

  // Signup Request Management
  getSignupRequests: async (params = {}) => {
    return apiService.get('/super-admin/signup-requests', { params });
  },

  approveSignupRequest: async (id, data = {}) => {
    return apiService.post(`/super-admin/signup-requests/${id}/approve`, data);
  },

  rejectSignupRequest: async (id, data = {}) => {
    return apiService.post(`/super-admin/signup-requests/${id}/reject`, data);
  },

  // Tenant Management
  getTenants: async (params = {}) => {
    return apiService.get('/super-admin/tenants', { params });
  },

  createTenant: async (data) => {
    return apiService.post('/super-admin/tenants', data);
  },

  getTenant: async (id) => {
    return apiService.get(`/super-admin/tenants/${id}`);
  },

  updateTenant: async (id, data) => {
    return apiService.put(`/super-admin/tenants/${id}`, data);
  },

  activateTenant: async (id) => {
    return apiService.post(`/super-admin/tenants/${id}/activate`);
  },

  suspendTenant: async (id, reason = '') => {
    return apiService.post(`/super-admin/tenants/${id}/suspend`, { reason });
  },

  // Domain Management
  getDomains: async (params = {}) => {
    return apiService.get('/super-admin/domains', { params });
  },

  getDomainStats: async () => {
    return apiService.get('/super-admin/domains/stats');
  },

  createDomainConfiguration: async (data) => {
    return apiService.post('/super-admin/domains', data);
  },

  getDomainConfiguration: async (id) => {
    return apiService.get(`/super-admin/domains/${id}`);
  },

  updateDomainConfiguration: async (id, data) => {
    return apiService.put(`/super-admin/domains/${id}`, data);
  },

  deleteDomainConfiguration: async (id) => {
    return apiService.delete(`/super-admin/domains/${id}`);
  },

  verifyDomainDns: async (id) => {
    return apiService.post(`/super-admin/domains/${id}/verify`);
  },

  enableDomainSsl: async (id) => {
    return apiService.post(`/super-admin/domains/${id}/enable-ssl`);
  },

  checkSubdomainAvailability: async (subdomain) => {
    return apiService.get('/super-admin/domains/available-subdomains', {
      params: { subdomain }
    });
  },

  checkDomainDns: async (id) => {
    return apiService.get(`/super-admin/domains/${id}/check-dns`);
  },

  getDomainSslInfo: async (id) => {
    return apiService.get(`/super-admin/domains/${id}/ssl-info`);
  },

  bulkDomainAction: async (action, domainIds) => {
    return apiService.post('/super-admin/domains/bulk-action', {
      action,
      domain_ids: domainIds
    });
  },

  // Analytics & Reports
  getDashboardStats: async () => {
    return apiService.get('/super-admin/dashboard/stats');
  },

  getSystemMetrics: async (timeframe = '7d') => {
    return apiService.get('/super-admin/analytics/metrics', { 
      params: { timeframe } 
    });
  },

  getUserAnalytics: async (params = {}) => {
    return apiService.get('/super-admin/analytics/users', { params });
  },

  getTenantAnalytics: async (params = {}) => {
    return apiService.get('/super-admin/analytics/tenants', { params });
  },

  // System Settings
  getSystemSettings: async () => {
    return apiService.get('/super-admin/settings');
  },

  updateSystemSettings: async (data) => {
    return apiService.put('/super-admin/settings', data);
  },

  // Maintenance & Support
  getSystemHealth: async () => {
    return apiService.get('/super-admin/system/health');
  },

  backupDatabase: async () => {
    return apiService.post('/super-admin/system/backup');
  },

  getAuditLogs: async (params = {}) => {
    return apiService.get('/super-admin/audit-logs', { params });
  },

  // Notifications
  getNotifications: async (params = {}) => {
    return apiService.get('/super-admin/notifications', { params });
  },

  markNotificationRead: async (id) => {
    return apiService.put(`/super-admin/notifications/${id}/read`);
  },

  sendBroadcast: async (data) => {
    return apiService.post('/super-admin/broadcast', data);
  },
};